export const translations = {
  navigation: {
    monitoring: {
      fr: 'Surveillance',
      en: 'Monitoring'
    },
    incidentResponse: {
      fr: 'Gestion des Incidents',
      en: 'Incident Response'
    },
    threatHunting: {
      fr: 'Détection des Menaces',
      en: 'Threat Hunting'
    },
    siem: {
      fr: 'SIEM',
      en: 'SIEM'
    },
    contact: {
      fr: 'Contactez-nous',
      en: 'Contact Us'
    }
  },
  home: {
    hero: {
      title: {
        fr: 'La Sécurité Informatique pour Votre Entreprise',
        en: 'Cybersecurity for Your Business'
      },
      subtitle: {
        fr: 'Solutions de cybersécurité sur mesure pour les entreprises',
        en: 'Tailored cybersecurity solutions for businesses'
      },
      cta: {
        start: {
          fr: 'Commencer',
          en: 'Get Started'
        },
        demo: {
          fr: 'Démonstration',
          en: 'Schedule Demo'
        }
      }
    },
    features: {
      title: {
        fr: 'Solutions de Sécurité Complètes',
        en: 'Comprehensive Security Solutions'
      },
      monitoring: {
        title: {
          fr: 'Surveillance 24/7',
          en: '24/7 Monitoring'
        },
        description: {
          fr: 'Surveillance continue de votre infrastructure avec détection des menaces en temps réel',
          en: 'Continuous infrastructure monitoring with real-time threat detection'
        }
      },
      incidentResponse: {
        title: {
          fr: 'Gestion des Incidents',
          en: 'Incident Response'
        },
        description: {
          fr: 'Réponse rapide et efficace aux incidents de sécurité avec résolution détaillée',
          en: 'Swift and effective response to security incidents with detailed resolution'
        }
      },
      threatHunting: {
        title: {
          fr: 'Détection des Menaces',
          en: 'Threat Detection'
        },
        description: {
          fr: 'Identification et élimination proactive des menaces potentielles',
          en: 'Proactive identification and elimination of potential threats'
        }
      },
      siem: {
        title: {
          fr: 'Gestion SIEM',
          en: 'SIEM Management'
        },
        description: {
          fr: 'Système avancé de gestion des informations et événements de sécurité',
          en: 'Advanced security information and event management system'
        }
      }
    },
    cta: {
      title: {
        fr: 'Prêt à Sécuriser Votre Entreprise?',
        en: 'Ready to Secure Your Business?'
      },
      subtitle: {
        fr: 'Découvrez nos solutions de sécurité adaptées à vos besoins',
        en: 'Discover our security solutions tailored to your needs'
      },
      button: {
        fr: 'Planifier une Consultation',
        en: 'Schedule a Consultation'
      }
    }
  },
  monitoring: {
    hero: {
      title: {
        fr: 'Surveillance 24/7',
        en: '24/7 Monitoring'
      },
      subtitle: {
        fr: 'Surveillance continue et détection des menaces en temps réel pour protéger votre infrastructure',
        en: 'Continuous surveillance and real-time threat detection to protect your infrastructure'
      }
    },
    features: {
      realtime: {
        title: {
          fr: 'Surveillance en Temps Réel',
          en: 'Real-time Monitoring'
        },
        description: {
          fr: 'Surveillance continue de votre réseau, systèmes et applications avec alertes instantanées',
          en: 'Continuous monitoring of your network, systems, and applications with instant alerts'
        }
      },
      alerts: {
        title: {
          fr: 'Alertes Instantanées',
          en: 'Instant Alerts'
        },
        description: {
          fr: 'Notification immédiate des incidents de sécurité avec contexte détaillé',
          en: 'Immediate notification of security incidents with detailed context'
        }
      },
      defense: {
        title: {
          fr: 'Défense Proactive',
          en: 'Proactive Defense'
        },
        description: {
          fr: 'Mécanismes avancés de détection et prévention des menaces',
          en: 'Advanced threat detection and prevention mechanisms'
        }
      }
    },
    howItWorks: {
      title: {
        fr: 'Comment Fonctionne Notre Surveillance',
        en: 'How Our Monitoring Works'
      },
      steps: {
        collection: {
          title: {
            fr: 'Collecte Continue des Données',
            en: 'Continuous Data Collection'
          },
          description: {
            fr: 'Notre plateforme SIEM collecte et analyse en permanence les données de tous vos systèmes',
            en: 'Our SIEM platform continuously collects and analyzes data from all your systems'
          }
        },
        analysis: {
          title: {
            fr: 'Analyse en Temps Réel',
            en: 'Real-time Analysis'
          },
          description: {
            fr: 'Algorithmes avancés et modèles d\'apprentissage pour détecter les menaces',
            en: 'Advanced algorithms and machine learning models to detect threats'
          }
        },
        response: {
          title: {
            fr: 'Réponse Immédiate',
            en: 'Immediate Response'
          },
          description: {
            fr: 'Nos experts en sécurité agissent immédiatement sur les menaces détectées',
            en: 'Our security experts take immediate action on detected threats'
          }
        }
      }
    },
    cta: {
      title: {
        fr: 'Prêt à Sécuriser Votre Infrastructure?',
        en: 'Ready to Secure Your Infrastructure?'
      },
      subtitle: {
        fr: 'Commencez avec notre service de surveillance 24/7',
        en: 'Get started with our 24/7 monitoring service'
      },
      button: {
        fr: 'Demander une Démo',
        en: 'Schedule a Demo'
      }
    }
  },
  footer: {
    privacy: {
      fr: 'Confidentialité',
      en: 'Privacy'
    },
    terms: {
      fr: 'Conditions',
      en: 'Terms'
    },
    contact: {
      fr: 'Contact',
      en: 'Contact'
    },
    rights: {
      fr: 'Tous droits réservés',
      en: 'All rights reserved'
    },
    monitoring: {
      fr: 'Surveillance',
      en: 'Monitoring'
    },
    incidentResponse: {
      fr: 'Gestion des Incidents',
      en: 'Incident Response'
    },
    threatHunting: {
      fr: 'Détection des Menaces',
      en: 'Threat Hunting'
    }
  }
};